import { Link } from "react-router-dom";
import styles from "./Articles.module.scss";

export const Article2 = () => {
  return (
    <div className={styles.articles__wrapper}>
      <Link to={"/articles"}>&#8592; Назад к статьям</Link>
      <h5 className={styles.articles__header}>
        Психологическое консультирование
      </h5>
      <p className={styles.articles__pharagraph}>
        Человек в сложной жизненной ситуации теряет собственный внутренний
        ресурс, и появляется нужда во внешней поддержке. Кто-то обращается за
        помощью к близким, к друзьям, решает личностные проблемы другим образом.
        Грамотным подходом зрелого человека в желании разобраться с отношениями,
        переживаниями, сомнениями это понять,{" "}
        <b>что нужна психологическая консультация.</b>
      </p>
      <h5 className={styles.articles__header}>
        Когда нужна психологическая консультация?
      </h5>
      <p className={styles.articles__pharagraph}>
        Психологическое состояние фактор физического здоровья и социального
        благополучия. Внимательное отношение к себе позволит вовремя заметить
        негативные изменения психологического тонуса:
        <ol>
          <li>Беспричинная усталость;</li>
          <li>Раздражительность, тревожность, агрессия;</li>
          <li>Нарушение отношений с близкими, коллегами;</li>
          <li>Утрата веры в себя;</li>
          <li>Нарушение сна, панические атаки, страхи;</li>
          <li>Зависимость пищевая, алкогольная, др.</li>
        </ol>
        Эти и другие изменения привычного психологического состояния повод
        посетить психолога. А поддержка в ситуации жизненной трагедии - развода,
        утраты близких, других сложных обстоятельств - психологом,
        психотерапевтом или психиатром необходима.
      </p>
      <h5 className={styles.articles__header}>
        Профессиональная психологическая консультация
      </h5>
      <p className={styles.articles__pharagraph}>
        <b>Профессиональная психологическая консультация</b> вид межличностного
        взаимодействия психолога и клиента. Это специальным образом
        организованное общение, в ходе которого психолог помогает клиенту
        осознать проблему и поддержать в выборе вариантов решения.
        Психологическая процедура опирается на разные теоретические подходы,
        проводится в разных формах, с применением различных методов и
        технологий.
      </p>
      <h5 className={styles.articles__header}>
        Психологическая консультация Онлайн
      </h5>
      <p className={styles.articles__pharagraph}>
        Работа психолога с клиентом в онлайн, в том числе и с использованием
        электронных программ, активно применяются в современной психологической
        практике. В сети интернет найдется масса предложений получить онлайн -
        консультацию. Заявленный профессионализм консультанта в условиях онлайн
        взаимодействия не всегда соответствует действительности. Консультации в
        этом случае бесполезны, или вредны. Выбор интернет-ресурса для решения
        психологических вопросов должен быть обдуманным. Профессиональный подход
        нужен и при выборе электронных приложений. По оценкам пользователей,
        внимания заслуживает электронная программа{" "}
        <b>психологического онлайн консультирования</b> PSY Cards.
      </p>
      <h5 className={styles.articles__header}>Приложение PSYCards</h5>
      <p className={styles.articles__pharagraph}>
        Приложение PSYCards онлайн ресурс, качество которого отвечает
        профессиональным стандартам психологической помощи. Оно применяется для
        проведения психологических консультаций и трансформационных игр с
        применением метафорических ассоциативных карт в Онлайн-среде.
        Достоинство программы: легкость в использовании, информационная
        поддержка, обратная связь, постоянное обновление с учетом мнений
        пользователей. Также программа дает загружать рабочие материалы,
        консультации, игры. Пользователи программы рекомендуют использовать
        Приложение PSYCards в работе психолога.
      </p>
    </div>
  );
};
